import styles from './styles.module.css'

export function AppProviderLogos({ provider, appIcon }: { provider: string; appIcon: string }) {
  return (
    <div className={styles.container}>
      <img src={appIcon} alt="App Icon" className={styles.appIcon} />
      <div className={styles.providerLogo}>
        <wui-logo logo={provider as any}></wui-logo>
      </div>
    </div>
  )
}
